export { ForecastPage as default } from '@/components/enpages/Ir/Financial/Forecast'
